import { createSelector } from 'reselect';
import { IceBreakerModel } from '../model/IceBreakerModel';
import { StoreState } from '../store-interfaces';

const selectIceBreakers = (state: StoreState) => state.iceBreakers;

export const selectFacebookIceBreaker = createSelector(
  [selectIceBreakers],
  iceBreakers =>
    iceBreakers.facebook.entities[0] as IceBreakerModel | undefined,
);
export const selectIGIceBreaker = createSelector(
  [selectIceBreakers],
  iceBreakers =>
    iceBreakers.instagram.entities[0] as IceBreakerModel | undefined,
);
